module.exports = __webpack_public_path__ + "img/history_lab_logo_white.44516e58.png";